module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prologue")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“Brennan! Wait!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris ran after his older brother, legs pumping quickly. His shouts for Brennan to slow down were ignored, and no matter how hard he tried, he couldn’t catch up. Not only did the ten-year-old have longer legs, but countless hours on the T-ball field had made him really fast. Chris was still struggling with his lifejacket, making it even harder to keep up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brennan jumped into the small dingy at the end of the dock and quickly unwound the mooring rope. Chris stumbled when he crossed from the lake’s sandy shoreline to the dock but managed to regain his footing. Brennan was close to casting off when Chris made it to the rowboat’s side. Panting heavily, he lifted his arms to reach out for Brennan to help him down into the boat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can’t come, Chris.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris’s breath caught in his throat, his eyes immediately watering.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were being a baby the whole way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not a baby!” Chris yelled. “I want to go in the boat!” Brennan glared at him. “I’ll tell Dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With an aggravated breath, Brennan finally reached up and let Chris fall into his arms. The boat dipped with the additional weight, rocking tenuously until Brennan regained his balance and placed Chris down on one of the benches. They glowered at each other as Brennan grabbed the oars and pulled away from the dock.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris looked into the water. The lake was pretty in the summertime. He was hoping to catch a glimpse of the monster Dad had told them about on the drive up. Apparently monsters liked to live in lakes that were too small for motorboats. Dad and Aunt Lisa had also argued about whether monsters liked eating six-year-olds, but as far as he could tell, Aunt Lisa had won and he was safe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The waters were too murky to see any monsters, so Chris settled back into his seat to watch Brennan row. He didn’t talk and Chris’s spirits fell when he saw the cross look on his face. Chris "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hadn’t")]), _vm._v(" been a baby on the drive up. Brennan wouldn’t share his things, and sharing was important, so Chris had told on him. But they’d been up at the lake a whole hour now, and the car ride was quickly fading into unpleasant memory.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bren, do you think the monster is blue or green?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brennan’s jaw clenched and he didn’t answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think blue. That way, he can hide better in the water. Like the snakes we saw at the zoo last week. Snakes are really cool. Did you know they like to just sit on rocks? It’s called basting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Basking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s what I said. Isn’t that cool?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brennan took a deep breath. “Stop talking, Chris.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I said stop talking! All you do is talk. All day, it’s just talk, talk, talk, talk, talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The tears returned, and Chris could feel his face turning red. His bottom lip quivered, out of his control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you’re such a crybaby. That’s probably why Mom left.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You take that back!” Chris choked on a hiccupping sob.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris jumped forward, his fists balled up and swinging wildly. “Take it back!”")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brennan dropped one of the oars in surprise, as an ineffectual blow glanced off his forearm. He shouted in surprise and lashed back, catching the edge of Chris’s lifejacket. Chris sprawled to the deck, his body heaving with sobs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Chris, I’m sor—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Leave me alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But, Chris—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I said leave me alone!” The scream ripped through the air, sending far-flung echoes cutting through the surrounding stillness. Chris felt his chest swell, and a sharp ache hit his temple, drawing a keening wail of surprise. There was a thump beside him, but he didn’t look up. His breath came in erratic gasps that burned his chest, and he couldn’t force himself to look up at Brennan’s angry face anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, his sobs dwindled away and he took a few calming breaths, rubbing at his eyes. Sitting up, he frowned when he saw that his brother had dropped one of the oars into the water and was just lying down instead of trying to grab it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Brennan?” He crawled closer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brennan looked like he was sleeping, but his lips were the color of a bruise. Chris touched his brother’s arm, gasping at the cold-apple skin texture.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Brennan?” Chris shook Brennan’s shoulder. “Stop it!” He shook him again, repeating his brother’s name over and over, trying to wake him up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The world fell into complete silence around him, interrupted only by the sound of him screaming his brother’s name.")])])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page07"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031994f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426890574_fm04.vue
// module id = 78
// module chunks = 0